import { render } from "./WorkReports.vue?vue&type=template&id=860412b6&scoped=true&ts=true&lang=pug"
import script from "./WorkReports.vue?vue&type=script&lang=ts"
export * from "./WorkReports.vue?vue&type=script&lang=ts"

import "./WorkReports.vue?vue&type=style&index=0&id=860412b6&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-860412b6"]])

export default __exports__